import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import auth from "../../firebase.init";
import Loading from "../Shared/Loading";

const AddProduct = () => {
  const [user, userLoading] = useAuthState(auth);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const [loading, setLoading] = useState(false);

  const { data: brandsInAddProducts, isLoading } = useQuery(
    "brandsInAddProducts",
    () =>
      fetch("https://evening-peak-35730.herokuapp.com/brands").then((res) => {
        return res.json();
      })
  );

  if (userLoading || isLoading || loading) {
    return <Loading></Loading>;
  }

  const imageStorageKey = "c4016c785641be139f6ea8c30408feed";

  const onSubmit = async (data) => {
    // console.log(data);
    setLoading(true);

    const image = data.product_image[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStorageKey}`;

    const res = await fetch(url, {
      method: "POST",
      body: formData,
    });
    const result = await res.json();
    if (result) {
      // console.log(result);
      if (result.success) {
        const img = result.data.url;
        const product = {
          product_name: data.product_name,
          product_image: img,
          product_brand_slug: data.product_brand_slug,
          product_price: data.product_price,
          stock: data.stock,
        };

        const response = await fetch(
          `https://evening-peak-35730.herokuapp.com/product/${user?.email}`,
          {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(product),
          }
        );
        const result2 = await response.json();
        console.log(result2);
        if (result2) {
          setLoading(false);
          if (!result2?.success) {
            toast.error(result2?.message);
          } else {
            const updateTotalDataStatus = { status: "increaseProducts" };
            const response3 = await fetch(
              `https://evening-peak-35730.herokuapp.com/updateTotalProductsAndBrands/${user?.email}`,
              {
                method: "PUT",
                headers: {
                  "content-type": "application/json",
                  authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                body: JSON.stringify(updateTotalDataStatus),
              }
            );
            const result3 = await response3.json();
            if (result3) {
              toast.success("Product Added Successfully. ALhamdulillah!!");
            } else {
              toast(
                "Product Added Successfully. ALhamdulillah!!. But total Products doesn't update!!!"
              );
            }
          }
          reset();
        }
      }
    }
  };

  return (
    <div>
      <h1 className="text-xl text-accent text-center my-4 font-bold">
        Add A New Product
      </h1>
      <div className="card bg-primary py-5">
        <div className="card-body">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-100 md:w-6/12 mx-auto"
          >
            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Product's Name
                </span>
              </label>
              <input
                type="text"
                placeholder="product's name"
                className="input input-bordered text-primary"
                {...register("product_name", {
                  required: {
                    value: true,
                    message: "Product's name is required.",
                  },
                })}
              />
              <label className="label">
                {errors.product_name?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.product_name.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Product's Image
                </span>
              </label>
              <input
                type="file"
                placeholder="product's image"
                className="input-bordered text-white"
                {...register("product_image", {
                  required: {
                    value: true,
                    message: "Product's image is required.",
                  },
                })}
              />
              <label className="label">
                {errors.product_image?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.product_image.message}
                  </span>
                )}
              </label>
            </div>

            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Select Product's Brand
                </span>
              </label>
              <select
                className="select"
                {...register("product_brand_slug", {
                  required: {
                    value: true,
                    message: "Product brand is required.",
                  },
                })}
              >
                <option disabled selected value="">
                  Select Product's Brand
                </option>
                {brandsInAddProducts.map((brand) => (
                  <option key={brand?._id} value={brand?.brand_slug}>
                    {brand?.brand_name}
                  </option>
                ))}
              </select>
              <label className="label">
                {errors.product_brand_slug?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.product_brand_slug.message}
                  </span>
                )}
              </label>
            </div>

            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Product's Price
                </span>
              </label>
              <input
                type="text"
                placeholder="product's price"
                className="input input-bordered text-primary"
                {...register("product_price", {
                  required: {
                    value: true,
                    message: "Product price is required.",
                  },
                })}
              />
              <label className="label">
                {errors.product_price?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.product_price.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Total Products
                </span>
              </label>
              <input
                type="text"
                placeholder="total products"
                className="input input-bordered text-primary"
                {...register("stock", {
                  required: {
                    value: true,
                    message: "Total Products is required.",
                  },
                })}
              />
              <label className="label">
                {errors.stock?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.stock.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control mt-6">
              <button className="btn btn-neutral text-primary font-bold">
                Add Products
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
